namespace AgerLMS.Logging {
    export interface LessonWatchLogRow {
        Id?: number;
        LessonId?: number;
        LastSecond?: number;
        TotalSecond?: number;
        IpNumber?: string;
        AuthToken?: string;
        UserAgent?: string;
        LessonLessonName?: string;
        LessonLessonDescription?: string;
        LessonCourseId?: number;
        LessonLessonType?: number;
        CourseName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace LessonWatchLogRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Logging.LessonWatchLog';
        export const deletePermission = 'Logging:LessonWatchLog:Delete';
        export const insertPermission = 'Logging:LessonWatchLog:Insert';
        export const readPermission = 'Logging:LessonWatchLog:Read';
        export const updatePermission = 'Logging:LessonWatchLog:Update';

        export declare const enum Fields {
            Id = "Id",
            LessonId = "LessonId",
            LastSecond = "LastSecond",
            TotalSecond = "TotalSecond",
            IpNumber = "IpNumber",
            AuthToken = "AuthToken",
            UserAgent = "UserAgent",
            LessonLessonName = "LessonLessonName",
            LessonLessonDescription = "LessonLessonDescription",
            LessonCourseId = "LessonCourseId",
            LessonLessonType = "LessonLessonType",
            CourseName = "CourseName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
